import LoLFullReport from './LoLFullReport';

export default LoLFullReport;
